import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { releaseNoteAllJp } from "../../i18n/releaseNotes/releaseNoteAllJp";
import { releaseNoteAllEn } from "../../i18n/releaseNotes/releaseNoteAllEn";
import localizationKeys from "../../i18n/localizationKeys";
import dayjs from "dayjs";

const styles = {
  releaseNoteInfoArea: {
    width: "90%",
    margin: "auto",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginBottom: "10px",
  },
    releaseNoteTitle: {
    fontSize: "32px",
    marginBottom: "20px",
  },
  releaseNoteNoteArea: {
    width: "90%",
    margin: "auto",
    marginTop: "20px",
  },
  releaseNoteText: {
    color: "#fff",
  },
  releaseNoteInfoTitle: {
    fontStyle: "italic",
    marginRight: "5px",
  },
  newFeatureTitle: {
    fontWeight: 600,
    color: "#fff",
    marginTop: "35px",
    marginBottom: "15px",
  },
  newFeatureContent: {
    color: "#fff",
    marginTop: "5px",
    "&::before": {
      content: '"• "',
    },
  },
  newFeatureSubContent: {
    marginLeft: "20px",
    marginTop: "5px",
  },
  image: {
    width: "90%",
    marginLeft: "5%",
    height: "auto",
  },
  separateLine: {
    border: "none",
    borderTop: "1px solid #fff",
    margin: "40px 0",
  },
}

export const ReleaseNoteContent = () => {
  const {t, i18n} = useTranslation();
  const releaseNoteAll = i18n.language === "ja" ? releaseNoteAllJp : releaseNoteAllEn;
  return (
    <Box component={"div"} sx={{margin: "0 25%"}}>
    {releaseNoteAll.map((note, noteIdx) => 
      note[0].version ? (
        <div key={`${noteIdx}_note`}>
          <Box component={"div"} sx={styles.releaseNoteInfoArea}>
            <Box component={"div"} sx={{...styles.releaseNoteText, ...styles.releaseNoteTitle}}>
              {i18n.language === "ja" ? `${t(localizationKeys.NowReleased_lower)}${note[0].version}` : `${note[0].version}${t(localizationKeys.NowReleased_lower)}`}
            </Box>
            <Box component={"span"} sx={{...styles.releaseNoteText, ...styles.releaseNoteInfoTitle}}>
              {t(localizationKeys.Released_lower)}
            </Box>
            <Box component={"span"} sx={{...styles.releaseNoteText, marginRight: "15px"}}>
              {i18n.language === "ja" ? dayjs(note[0].releaseDate).format("YYYY/MM/DD HH:mm,") : dayjs(note[0].releaseDate).format("MM/DD/YYYY HH:mm.")}
            </Box>
            <Box component={"span"} sx={{...styles.releaseNoteText, ...styles.releaseNoteInfoTitle}}>
              {t(localizationKeys.Updated_lower)}
            </Box>
            <Box component={"span"} sx={styles.releaseNoteText}>
              {i18n.language === "ja" ? dayjs(note[0].updatedDate).format("YYYY/MM/DD HH:mm") : dayjs(note[0].updatedDate).format("MM/DD/YYYY HH:mm.")}
            </Box>
          </Box>
          <Box component={"div"} sx={styles.releaseNoteNoteArea}>
            <Box component={"div"} sx={styles.releaseNoteText}>
              {note[0].introduction}
            </Box>
            {note.slice(1).map((section, sectionIdx) => (
              <div key={ `${noteIdx}_${section.title}_${sectionIdx}_area` }>
                <Box component={"div"} sx={styles.newFeatureTitle} key={ `${noteIdx}_${section.title}_${sectionIdx}` }>
                  { section.title }
                </Box>
                {section.descriptions.map((item, itemIdx) => (
                  <Box component={"div"} sx={styles.releaseNoteText} key={`${noteIdx}_${section.title}_${item}_${itemIdx}`}>
                    {item.split("\n").map((line, lineIdx) => (
                      <Box
                        component={"div"}
                        sx={lineIdx === 0 ? styles.newFeatureContent : styles.newFeatureSubContent}
                        key={`${noteIdx}_${section.title}_${item}_${itemIdx}_${lineIdx}`}
                      >
                        {line}
                      </Box>
                    ))}
                  </Box>
                ))}
                {section.images.map((img, imgIdx) => (
                  <Box
                    component={"img"}
                    key={`${section.title}_img_${imgIdx}`}
                    src={img}
                    sx={styles.image}
                  />
                ))}
              </div>
            ))}
            <br />
            <br />
            <Box component={"div"} sx={styles.releaseNoteText}>
              {note[0].conclusion}
            </Box>
          </Box>
          {(noteIdx !== releaseNoteAll.length - 1) && (
            <Box component={"hr"} sx={styles.separateLine} />
          )}
        </div>
      ) : (
        <div key={`${noteIdx}_info`}>
          <Box component={"div"} sx={styles.releaseNoteInfoArea}>
            <Box component={"div"} sx={{...styles.releaseNoteText, ...styles.releaseNoteTitle}}>
              Information
            </Box>
            <Box component={"span"} sx={{...styles.releaseNoteText, ...styles.releaseNoteInfoTitle}}>
              Date
            </Box>
            <Box component={"span"} sx={{...styles.releaseNoteText, marginRight: "15px"}}>
              {i18n.language === "ja" ? dayjs(note[0].startDate).format("YYYY/MM/DD HH:mm") : dayjs(note[0].startDate).format("MM/DD/YYYY HH:mm")}
            </Box>
            <Box component={"span"} sx={{...styles.releaseNoteText, marginRight: "15px"}}>
              -
            </Box>
            <Box component={"span"} sx={styles.releaseNoteText}>
              {i18n.language === "ja" ? dayjs(note[0].endDate).format("YYYY/MM/DD HH:mm") : dayjs(note[0].endDate).format("MM/DD/YYYY HH:mm")}
            </Box>
          </Box>
          <Box component={"div"} sx={styles.releaseNoteNoteArea}>
            <Box component={"div"} sx={styles.releaseNoteText}>
              {note[0].introduction}
            </Box>
            <br />
            <Box component={"div"} sx={styles.releaseNoteText}>
              {note[0].conclusion}
            </Box>
          </Box>
          {(noteIdx !== releaseNoteAll.length - 1) && (
            <Box component={"hr"} sx={styles.separateLine} />
          )}
        </div>
      )
    )}
  </Box>
  )
}